var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTopicAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 1.25H2.08333C1.48503 1.25 1 1.73503 1 2.33333V13.1667C1 13.765 1.48503 14.25 2.08333 14.25H12.9167C13.515 14.25 14 13.765 14 13.1667V2.33333C14 1.73503 13.515 1.25 12.9167 1.25Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33339 7.38894C6.33056 7.38894 7.13894 6.58056 7.13894 5.58339C7.13894 4.58622 6.33056 3.77783 5.33339 3.77783C4.33622 3.77783 3.52783 4.58622 3.52783 5.58339C3.52783 6.58056 4.33622 7.38894 5.33339 7.38894Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.0833L10.0278 8.47217L6.41667 11.7222L3.88889 9.5555L1 11.7222",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTopicAlbum);
export default __webpack_public_path__ + "static/media/filter-topic-album.ac6d962c905fbf31c2504bd67e673ebc.svg";
export { ForwardRef as ReactComponent };